import React, { useState, useEffect } from "react";
import { Table, Button, Spin } from "antd";
import "./Offices.scss";

import add from "../../../Assets/svg/addButton.svg";
import deleteIcon from "../../../Assets/svg/table-action-delete.svg";
import editIcon from "../../../Assets/svg/table-action-edit.svg";
import previewIcon from "../../../Assets/svg/table-action-preview.svg";
import numberOfMembers from "../../../Assets/svg/numberOfMembers.svg";
import deleteMemberIcon from "../../../Assets/svg/deleteMemberIcon.svg";
import DeleteComponent from "../../components/DeleteComponent/DeleteComponent";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import { httpService } from "../../../services/httpService.service";
import { isAuthorized } from "../../../services/authService";
import { RolesEnum } from "../../../services/rolesEnum";
import TableFilters from "./TableFilters";
import AddOffice from "./AddOffice";
import EditOffice from "./EditOffice";
import PreviewOffice from "./PreviewOffice";
import done from "../../../Assets/svg/done.svg";

const Offices = () => {
  const [showAddIpModal, setShowAddIpModal] = useState(false);
  const [showEditIpModal, setShowEditIpModal] = useState(false);
  const [showPreviewIpModal, setShowPreviewIpModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const workspaceId = localStorage.getItem("currentContractId");
  const [loading, setLoading] = useState(false);
  const [ips, setIPs] = useState([]);
  const [totalIPs, setTotalIPs] = useState(0);
  const [filters, setFilters] = useState({
    search: "",
    CityId: "",
    StateId: "",
    CountryId: "",
  });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 576);
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 576);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleToggleEditIpModal = (record) => {
    setSelectedRowData(record);
    setShowEditIpModal(!showEditIpModal);
  };

  const handleTogglePreviewIpModal = (record) => {
    setSelectedRowData(record);
    setShowPreviewIpModal(!showPreviewIpModal);
  };

  useEffect(() => {
    if (!showEditIpModal && !showPreviewIpModal) {
      setSelectedRowData(null); // Reset the selected row data when modals are closed
    }
  }, [showEditIpModal, showPreviewIpModal]);
  const handleToggleAddIpModal = () => {
    setShowAddIpModal(!showAddIpModal);
  };

  const fetchOffice = (current, pageSize) => {
    setLoading(true);

    const params = {
      Search: filters.search,
      CountryIds: filters.CountryId,
      pageNumber: current,
      pageSize: pageSize,
    };

    let countryString = "";
    params?.CountryIds?.length > 0 &&
      params?.CountryIds.forEach((country) => {
        countryString += `&CountryIds=${country}`;
      });
    const apiUrl = `api/Office/getAll?search=${params?.Search}&pageSize=${params?.pageSize}&pageNumber=${params?.pageNumber}${countryString}`;

    httpService.get(
      apiUrl,
      (response) => {
        const data = response?.data?.map((item) => ({
          key: item?.id,
          id: item?.id,
          name: item?.name,
          country:
            item?.countries?.map((country) => country?.stateName).join(", ") ||
            "N/A",
        }));

        setIPs(data);
        setPagination((prevPagination) => ({
          ...prevPagination,
          current: response?.metaData?.pageNumber,
          pageSize: response?.metaData?.pageSize,
          total: response?.metaData?.totalItemCount,
        }));
        setTotalIPs(response?.metaData?.totalItemCount);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching IPs:", error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchOffice(pagination.current, pagination.pageSize);
  }, [filters, pagination.current, pagination.pageSize]);

  const columns = [
    {
      title: <span className="styledTitle">Office Name</span>,
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text) => <span className="styledDataIndex">{text}</span>,
    },
    {
      title: <span className="styledTitle">Country</span>,
      dataIndex: "country",
      key: "country",
      sorter: (a, b) => {
        const countryA = a.country ? a.country.toString() : "";
        const countryB = b.country ? b.country.toString() : "";
        return countryA.localeCompare(countryB, undefined, {
          sensitivity: "base",
        });
      },
      render: (text) => <span className="styledDataIndex">{text}</span>,
    },
    {
      key: "action",
      fixed: isLargeScreen && ips?.length > 0 ? "right" : undefined,
      render: (text, record) => (
        <div className="actionDiv">
          {isAuthorized([
            RolesEnum.ProjectManager,
            RolesEnum.SystemAdmin,
            RolesEnum.FieldLogistics,
            RolesEnum.DataAnalyst,
            RolesEnum.FieldCoordinator,
            RolesEnum.FieldTeamLeader,
            RolesEnum.FieldEnumerator,
          ]) && (
            <img
              src={previewIcon}
              onClick={() => handleTogglePreviewIpModal(record)}
              style={{ cursor: "pointer" }}
              alt="Preview"
            />
          )}
          {isAuthorized([
            RolesEnum.ProjectManager,
            RolesEnum.SystemAdmin,
            RolesEnum.FieldLogistics,
            RolesEnum.DataAnalyst,
          ]) && (
            <img
              src={editIcon}
              onClick={() => handleToggleEditIpModal(record)}
              style={{ cursor: "pointer" }}
              alt="Edit"
            />
          )}
          {isAuthorized([
            RolesEnum.ProjectManager,
            RolesEnum.SystemAdmin,
            RolesEnum.FieldLogistics,
            RolesEnum.DataAnalyst,
          ]) && (
            <img
              src={deleteIcon}
              style={{ cursor: "pointer" }}
              onClick={() => handleDeleteIP(record.id)}
              alt="Delete"
            />
          )}
        </div>
      ),
    },
  ];

  const handleTableChange = (pagination) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }));
  };

  const handleDeleteIP = (id) => {
    setSelectedRowData({ id });
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);

    const itemToDelete = selectedRowData?.id;

    httpService.delete(
      `/api/Office?Id=${itemToDelete}&IsDeleted=true`,
      "",
      (response) => {
        // Use response.data if it exists, otherwise fallback to a default message
        const message =
          response?.data?.data ||
          "You have successfully deleted this office from your database!";

        setMessage({
          trigger: true,
          type: "success",
          icon: done,
          title: "Office deleted successfully",
          text: message,
        });

        setTimeout(() => {
          setMessage({
            trigger: false,
          });
        }, 3000);

        fetchOffice(pagination.current, pagination.pageSize);
        setLoading(false);
        setShowDeleteModal(false);
      },
      (error) => {
        const errorMessage =
          error?.errors?.[0]?.message ||
          error?.message ||
          "We had a problem deleting this office! Please try again later!";

        setMessage({
          trigger: true,
          type: "danger",
          icon: deleteMemberIcon,
          title: "Oops! A problem has occurred!",
          text: errorMessage,
        });

        fetchOffice(pagination.current, pagination.pageSize);
        setLoading(false);
        setShowDeleteModal(false);
        setTimeout(() => {
          setMessage({
            trigger: false,
          });
        }, 3000);
      }
    );
  };

  const handleAddEditIp = async () => {
    try {
      setLoading(true);
      await fetchOffice(pagination.current, pagination.pageSize);
    } catch (error) {
      // console.error("Error adding project:", error);
    } finally {
      // console.log("Setting loading to false");
      // setLoading(false);
    }
  };

  return (
    <div>
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      <div className="mainDivUserManagement px-5">
        <div className="userManagementHeader">
          <div className="userManagementHeaderFirst">
            <span className="userManagementHeaderText">Offices</span>
            <div className="numberOfMembers">
              <img src={numberOfMembers} alt="Members" />
              <span style={{ marginLeft: "7px" }}>
                {loading ? <Spin size="small" /> : totalIPs}
              </span>
            </div>
          </div>
          <div className="userManagementHeaderSecond">
            {isAuthorized([
              RolesEnum.ProjectManager,
              RolesEnum.SystemAdmin,
              RolesEnum.FieldLogistics,
              RolesEnum.DataAnalyst,
            ]) && (
              <Button className="addButtonTPM" onClick={handleToggleAddIpModal}>
                <img src={add} alt="Add" />
                Add New Office
              </Button>
            )}
          </div>
        </div>
        <TableFilters
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div style={{ overflowX: "auto", marginTop: "20px" }}>
          <Table
            // rowSelection={{ ...rowSelection, checkStrictly }}
            dataSource={ips}
            columns={ips?.length > 0 ? columns : []}
            className="tableTPM"
            loading={loading}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
            }}
            onChange={handleTableChange} // Add this line
          />
        </div>
      </div>
      <AddOffice
        visible={showAddIpModal}
        onClose={handleToggleAddIpModal}
        onSubmit={handleAddEditIp}
        setMessage={setMessage}
      />
      <EditOffice
        visible={showEditIpModal}
        onClose={handleToggleEditIpModal}
        record={selectedRowData}
        onSubmit={handleAddEditIp}
        setMessage={setMessage}
      />
      <PreviewOffice
        visible={showPreviewIpModal}
        onClose={handleTogglePreviewIpModal}
        record={selectedRowData}
      />
      <DeleteComponent
        visible={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        loading={loading}
        text={
          "You're about to delete this office. This action can’t be undone."
        }
        header={"Delete Office"}
      />
    </div>
  );
};

export default Offices;
